import { Injectable } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { IndexedService, OUTLINES_STORE } from '@damofire/data-commons';
import { WarehouseOutlineSegment } from '../../warehouse/warehouse.dto';
import { RemoteService } from './remote.service';
import { FirebaseWarehouseOutlineService } from '../../layout/firebase-warehouse-outline.service';

@Injectable()
export class WarehouseOutlineRemoteService extends RemoteService<WarehouseOutlineSegment> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseWarehouseService: FirebaseWarehouseOutlineService,
  ) {
    super(OUTLINES_STORE, idbService, networkService);
  }

  async add(division: string, data: WarehouseOutlineSegment[]): Promise<void> {
    await this.firebaseWarehouseService.create(division, data);
  }

  async delete(division: string, data: WarehouseOutlineSegment[]): Promise<void> {
    await this.firebaseWarehouseService.delete(division, data);
  }

  async update(division: string, data: WarehouseOutlineSegment[]): Promise<void> {
    await this.firebaseWarehouseService.update(division, data);
  }
}
